import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import {
  Button,
  ToggleControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import IconsModal from '../../components/IconsModal';
import { NOTICE_TYPES, getNoticeIcon } from './notice-types';
import { getIconClasses } from '../../utils/helpers';

export default function Inspector({ attributes, setAttributes }) {
  const { type, showIcon, iconName, iconType, dismissible } = attributes;

  const [isIconsModalOpen, setIsIconsModalOpen] = useState(false);

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Notice', 'brandy-blocks')} initialOpen>
          <ToggleGroupControl
            label={__('Type', 'brandy-blocks')}
            value={type}
            onChange={(next) => setAttributes({ type: next })}
            isBlock
            __nextHasNoMarginBottom
          >
            {Object.entries(NOTICE_TYPES).map(([value, { title }]) => (
              <ToggleGroupControlOption key={value} value={value} label={title} />
            ))}
          </ToggleGroupControl>

          <ToggleControl
            label={__('Show the icon', 'brandy-blocks')}
            checked={showIcon}
            onChange={(next) => setAttributes({ showIcon: next })}
            __nextHasNoMarginBottom
          />

          {showIcon && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                margin: '12px 0',
              }}
            >
              <i
                className={getIconClasses(getNoticeIcon(type, iconName), iconType)}
                style={{ fontSize: '24px' }}
              />
              <Button variant="secondary" onClick={() => setIsIconsModalOpen(true)}>
                {__('Change icon', 'brandy-blocks')}
              </Button>
              {iconName && (
                <Button
                  variant="tertiary"
                  onClick={() => setAttributes({ iconName: '' })}
                >
                  {__('Use the default', 'brandy-blocks')}
                </Button>
              )}
            </div>
          )}

          <ToggleControl
            label={__('Let readers dismiss it', 'brandy-blocks')}
            help={__(
              'The notice comes back on the next page load — it is not remembered.',
              'brandy-blocks'
            )}
            checked={dismissible}
            onChange={(next) => setAttributes({ dismissible: next })}
            __nextHasNoMarginBottom
          />
        </PanelBody>
      </InspectorControls>

      <IconsModal
        isIconsModalOpen={isIconsModalOpen}
        setIsIconsModalOpen={setIsIconsModalOpen}
        icon={{ name: getNoticeIcon(type, iconName), type: iconType }}
        setAttributes={(newAttrs) =>
          setAttributes({ iconName: newAttrs.name, iconType: newAttrs.type })
        }
      />
    </>
  );
}
